
import { faChevronDown } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Divider, Menu, MenuItem, styled } from "@mui/material";
import { FC, MouseEvent, useContext, useMemo, useState } from "react";
import { Link as RouteLink, useParams } from 'react-router-dom';
import ProjectContext from "../../../contexts/data/ProjectContext";
import StageContext from "../../../contexts/data/StageContext";
import LotContext from "../../../contexts/data/LotContext";
import StagesContext from "../../../contexts/data/StagesContext";
import LotsContext from "../../../contexts/data/LotsContext";
import { LinkContext } from "../../../contexts/layouts/LinkContext";

const StyledDivider = styled(Divider)(() => ({
    margin: `0 !important`
}));

const NavigationLotSelector: FC = () => {
    const params = useParams();

    const lotId = Number(params.lotId);

    const { createProjectLink, createStageLink, createLotLink, lotLinkEnabled } = useContext(LinkContext);
    
    const { data: project} = useContext(ProjectContext);
    const { data: stage } = useContext(StageContext);
    const { data: lot } = useContext(LotContext);
    const { idMap: stages } = useContext(StagesContext);
    const { data: lots } = useContext(LotsContext);
    
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

    const handleMenu = (event: MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const list = useMemo(() => {
        if (!project || !stages) {
            return undefined;
        }
        
        return lots?.map((x, i, a) => {
            return (
                [
                    <MenuItem 
                        key={x.id} 
                        component={RouteLink} 
                        to={createLotLink(project, x.stageId ? stages[x.stageId] : undefined, x)} 
                        onClick={handleClose}
                    >
                        {x.number}
                    </MenuItem>,
                    i < (a.length - 1) ? <StyledDivider key={`${x.id}-divider`} /> : null
                ]
            );
        })
    }, [lots, project, stages, createLotLink, handleClose])

    if (!lotLinkEnabled || !project) {
        return null;
    }
    
    return (
        <>
            <Button
                id="btn-lots"
                color="primary"
                aria-label="lot selection"
                aria-controls="menu-lots"
                aria-haspopup="true"
                sx={{mr: 2}}
                onClick={handleMenu}
                endIcon={<FontAwesomeIcon icon={faChevronDown} fixedWidth style={{fontSize: '1rem'}} />}
            >
                {
                    lotId && lot ?
                        lot.number :
                        'No Lot Selected'
                }
            </Button>
            <Menu
                id="menu-lots"
                anchorEl={anchorEl}
                keepMounted
                transformOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                open={anchorEl?.id === 'btn-lots'}
                onClose={handleClose}
                slotProps={{
                    list: {
                        disablePadding: true
                    }
                }}
            >
                <MenuItem component={RouteLink} to={stage ? createStageLink(project, stage) : createProjectLink(project)} onClick={handleClose}>All Lots</MenuItem>
                <StyledDivider />
                {
                    list
                }
            </Menu>
        </>
    )
}

export default NavigationLotSelector;